<a (click)="clicked()" title={{value}}>{{value}}</a>